<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import {
		pcaTextArr
	} from "element-china-area-data";
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				headDataII: getdata().headDataII,
				pcaTextArr,
			};
		},
		props: {
			headDataVI:{
				type: Array,
				default: [],
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			tableDataI: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {
			this.$nextTick(()=>{
			})
		},
		methods: {
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			forpz() {
				if (this.showpz) {
					this.$emit("forpz", "")
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 0) {
					if ([0, 1, 2, 3, 6, 7, 8, 9, 10, 11].includes(rowIndex)) {
						return {
							rowspan: 1,
							colspan: 2
						};
					} else {
						if (rowIndex == 4) {
							return {
								rowspan: 2,
								colspan: 1
							};
						}
						if (rowIndex == 5) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 12) {
							return {
								rowspan: 2,
								colspan: 1
							};
						}
						if (rowIndex == 13) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 14) {
							return {
								rowspan: 4,
								colspan: 1
							};
						}
						if (rowIndex == 15 || rowIndex == 16 || rowIndex == 17) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 18) {
							return {
								rowspan: 3,
								colspan: 1
							};
						}
						if (rowIndex == 19 || rowIndex == 20) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 21) {
							return {
								rowspan: 3,
								colspan: 1
							};
						}
						if (rowIndex == 22 || rowIndex == 23) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
					}
				}
				if (columnIndex == 1) {
					if ([0, 1, 2, 3, 6, 7, 8, 9, 10, 11].includes(rowIndex)) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			},
			spanmethodII({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					if ([0, 1, 2, 3, 4, 5, 6, 7, 27, 28, 29, 30, 31, 32, 33, 34, 35].includes(rowIndex)) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}	
				if (columnIndex == 0) {
					if ([0, 1, 2, 3, 4, 5, 6, 7, 27, 28, 29, 30, 31, 32, 33, 34, 35].includes(rowIndex)) {
						return {
							rowspan: 1,
							colspan: 2
						};
					} else {
						if (rowIndex == 8) {
							return {
								rowspan: 4,
								colspan: 1
							};
						}
						if (rowIndex == 9 || rowIndex == 10 || rowIndex == 11) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 12) {
							return {
								rowspan: 3,
								colspan: 1
							};
						}
						if (rowIndex == 13 || rowIndex == 14) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 15) {
							return {
								rowspan: 4,
								colspan: 1
							};
						}
						if (rowIndex == 16 || rowIndex == 17 || rowIndex == 18) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 19) {
							return {
								rowspan: 4,
								colspan: 1
							};
						}
						if (rowIndex == 20 || rowIndex == 21 || rowIndex == 22) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
						if (rowIndex == 23) {
							return {
								rowspan: 4,
								colspan: 1
							};
						}
						if (rowIndex == 24 || rowIndex == 25 || rowIndex == 26) {
							return {
								rowspan: 0,
								colspan: 0
							};
						}
					}
				}
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../valueAddedTax/index.less');
</style>
